import { createTracker } from 'usage-tracker';
const usageTracker = createTracker({
  standalone: true
});
export function trackInteraction(params) {
  usageTracker.track('Multi Account Contextual Copier', 'User Interaction', {
    count: params.count || '',
    action: params.action,
    assetType: params.assetType || ''
  });
}